import { Link } from "react-router-dom";
import logo from "@/assets/2022_COSMO_Signet_white.svg";
import HeaderButton from "./HeaderButton";
import MobileHeader from "./MobileHeader";
import {
  HomeIcon,
  DocumentTextIcon,
  ChartBarIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/20/solid";
import useWindowWidth from "@/hooks/useWindowWidth";
import { Tooltip } from "react-tooltip";

// Define section type for actions
export type AppSection = 'search' | 'profile';

// Update MenuLink type to include optional action
export type MenuLink = {
  name: string;
  mobileVisibility: boolean;
  order: number;
  url?: string; // Make URL optional
  icon: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & { title?: string | undefined; titleId?: string | undefined; } & React.RefAttributes<SVGSVGElement>>;
  visible: boolean;
  action?: AppSection; // Add action field
};

// Define Props for Header correctly
type HeaderProps = { 
  children?: React.ReactNode;
  onSectionChange?: (section: AppSection) => void; 
};

const menuLinks: MenuLink[] = [
  {
    name: "Projektsuche", // Renamed from Übersicht
    mobileVisibility: true,
    order: 1,
    // url: "/", // Remove URL, use action instead
    icon: HomeIcon,
    visible: true,
    action: 'search', // Trigger search section
  },
  {
    name: "Firmenprofil", // New menu item
    mobileVisibility: true,
    order: 2, // Insert between Projektsuche and Projekte
    icon: BuildingOfficeIcon, // Use new icon
    visible: true,
    action: 'profile', // Trigger profile section
  },
  {
    name: "Projekte",
    mobileVisibility: true,
    order: 3, // Renumber order
    url: "/projects",
    icon: DocumentTextIcon,
    visible: true,
  },
  {
    name: "Analysen",
    mobileVisibility: true,
    order: 4, // Renumber order
    url: "/analysis",
    icon: ChartBarIcon,
    visible: true,
  },
];

// Accept and use the onSectionChange prop
function Header({ children, onSectionChange }: HeaderProps) { 
  const windowWidth = useWindowWidth();

  // Sort links by order just in case
  const sortedLinks = menuLinks.sort((a, b) => a.order - b.order);

  return (
    <nav className="flex justify-between items-center h-14 gap-2 shrink-0 relative z-10">
      <div className="flex items-center gap-2">
        {/* Keep Logo/Brand Link */}
        <Link to="/" className="text-xl m-0 flex items-center gap-2" onClick={() => onSectionChange?.('search')}> {/* Reset to search on logo click */} 
          <img src={logo} alt="" className="h-6" />
          <p className="">COSMO</p>
        </Link>
        {children}
      </div>
      {windowWidth > 768 ? (
        <ul className="flex items-center gap-2">
          {sortedLinks.map((link) => {
            // Pass down onSectionChange handler to HeaderButton
            // HeaderButton props need to accept action and onSectionChange
            return <HeaderButton {...link} key={link.order} onSectionChange={onSectionChange} />;
          })}
        </ul>
      ) : (
        <div className="shrink-0">
           {/* Pass handler to MobileHeader */} 
           {/* MobileHeader props need to accept onSectionChange */} 
          <MobileHeader links={sortedLinks} onSectionChange={onSectionChange} /> 
        </div>
      )}
      <Tooltip id="header-tooltip" />
    </nav>
  );
}
export default Header; 